'use client';

import React from 'react';
import { showDrawerState, showModal } from '@/store/reducers/ui-slice';
import { Box, Button } from '@mui/material';
import { useDispatch } from 'react-redux';

import { GeneralDrawer, ModalDrawer } from '@/types/general';

export function ModalButton({
  text,
  icon,
  variant = 'contained',
  modal,
  drawer,
  color,
  size,
  content,
}: {
  text: string;
  icon?: React.ReactNode;
  variant?: 'contained' | 'text' | 'outlined';
  modal?: ModalDrawer;
  drawer?: GeneralDrawer;
  color?: 'inherit' | 'info' | 'primary' | 'secondary' | 'success' | 'error' | 'warning' | undefined;
  size?: 'small' | 'medium' | 'large' | undefined;
  content?: Record<string, unknown> | undefined;
}): React.JSX.Element {
  const dispatch = useDispatch();
  return (
    <Button
      onClick={() => {
        if (modal) {
          dispatch(showModal({ open: modal, content }));
        }
        if (drawer) {
          dispatch(showDrawerState(drawer));
        }
      }}
      variant={variant}
      color={color}
      startIcon={icon}
      size={size}
    >
      <Box sx={{ display: { xs: 'initial' } }}>{text}</Box>
    </Button>
  );
}
